<template>
  <transition
    :enter-active-class="animation.enter"
    :leave-active-class="animation.leave"
  >
    <div class="snack_bar" :style="{ ...positionStyle }" v-if="getSnack.isOpen">
      <div class="d-flex-row justify-start align-start gap-20">
        <div class="d-flex-row flex-1">
          <component :is="icon()">{{ icon() }}</component>
        </div>
        <div class="d-flex-column justify-start align-start flex-10 gap-6">
          <h4 class="regular-l f-w-600 font-family-2 t-white">
            {{ getSnack.title }}
          </h4>
          <p
            class="regular-l f-w-400 font-family-2 t-light description"
            style="word-wrap: break-word; max-width: 100%"
          >
            {{ getSnack.description }}
          </p>
        </div>
        <div @click="close" class="cursor-pointer">
          <CrossIcon />
        </div>
      </div>
      <div
        v-if="getSnack.showProgress"
        class="progress"
        :class="getSnack.type.toLocaleLowerCase()"
        :style="{
          animation: `slider_pagination ${getSnack.timeout}ms linear 1`,
        }"
      ></div>
    </div>
  </transition>
</template>

<script setup>
import Success from "../icons/snack/Success.vue";
import Error from "../icons/snack/Error.vue";
import PaymentRequest from "../icons/snack/PaymentRequest.vue";
import PaymentSuccess from "../icons/snack/PaymentSuccess.vue";
import PaymentError from "../icons/snack/PaymentError.vue";
import Wait from "../icons/snack/Wait.vue";
import CrossIcon from "../icons/CrossIcon.vue";
import { ref, computed, watch, onBeforeUnmount } from "vue";

// HOOKS
const { getSnack, resetSnack } = useGenericStore();
// REACTIVE VARIABLE
const timeoutInterval = ref(null);

const positionStyle = computed(() => {
  switch (getSnack.position) {
    case "bottom-left":
      return { bottom: "3%", left: "3%" };
    case "top-left":
      return { top: "3%", left: "3%" };
    case "top-right":
      return { top: "3%", right: "3%" };
    case "bottom-right":
      return { bottom: "3%", right: "3%" };
    default:
      return { bottom: "3%", left: "3%" };
  }
});

const animation = computed(() => {
  switch (getSnack.position) {
    case "bottom-left":
    case "top-left":
      return {
        enter: "blur-left-slide-in",
        leave: "blur-left-slide-out",
      };
    case "top-right":
    case "bottom-right":
      return {
        enter: "blur-right-slide-in",
        leave: "blur-right-slide-out",
      };
    default:
      return {
        enter: "blur-left-slide-in",
        leave: "blur-left-slide-out",
      };
  }
});

// METHODS

const icon = () => {
  if (getSnack.type.toLocaleLowerCase() === "success") {
    return Success;
  } else if (getSnack.type.toLocaleLowerCase() === "error") {
    return Error;
  } else if (getSnack.type.toLocaleLowerCase() === "paymentrequest") {
    return PaymentRequest;
  } else if (getSnack.type.toLocaleLowerCase() === "paymentsuccess") {
    return PaymentSuccess;
  } else if (getSnack.type.toLocaleLowerCase() === "paymenterror") {
    return PaymentError;
  } else if (getSnack.type.toLocaleLowerCase() === "wait") {
    return Wait;
  } else return null;
};

const close = () => {
  resetSnack();
  if (timeoutInterval.value) {
    clearTimeout(timeoutInterval.value);
  }
};

onBeforeUnmount(() => {
  if (timeoutInterval.value) {
    clearTimeout(timeoutInterval.value);
  }
});

watch(
  () => getSnack.isOpen,
  (isOpen) => {
    if (isOpen) {
      timeoutInterval.value = setTimeout(() => {
        close();
      }, getSnack.timeout);
    }
  }
);
</script>
